var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rule_content" }, [
    _c("h2", [_vm._v(_vm._s(_vm.$t("score.score_rules")))]),
    _vm._v(" "),
    _c("p", [_vm._v("1.什么是用户积分")]),
    _vm._v(" "),
    _c("p", [_vm._v("********")]),
    _vm._v(" "),
    _c("p", [_vm._v("2.如何获取用户积分")]),
    _vm._v(" "),
    _c("p", [_vm._v("********")]),
    _vm._v(" "),
    _c("p", [_vm._v("********")]),
    _vm._v(" "),
    _c("p", [_vm._v("********")]),
    _vm._v(" "),
    _c("p", [_vm._v("3.用户积分用途")]),
    _vm._v(" "),
    _c("p", [_vm._v("********")]),
    _vm._v(" "),
    _c("p", [_vm._v("********")]),
    _vm._v(" "),
    _c("p", [_vm._v("4.用户积分有效期")]),
    _vm._v(" "),
    _c("p", [_vm._v("********")]),
    _vm._v(" "),
    _c("p", [_vm._v("5.其他")]),
    _vm._v(" "),
    _c("p", [_vm._v("********")])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69371c64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69371c64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoreRule.vue
// module id = null
// module chunks = 